
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.ts"
import * as amdModule1 from "./adapters/contact-detail.ts"
import * as amdModule2 from "./adapters/csv-api.ts"
import * as amdModule3 from "./adapters/district-coordinator.ts"
import * as amdModule4 from "./adapters/district.ts"
import * as amdModule5 from "./adapters/gravity-bulk.ts"
import * as amdModule6 from "./adapters/gravity.ts"
import * as amdModule7 from "./adapters/import-schedule.js"
import * as amdModule8 from "./adapters/import-validation.js"
import * as amdModule9 from "./adapters/partner-contact-detail.ts"
import * as amdModule10 from "./adapters/school-class.ts"
import * as amdModule11 from "./adapters/school-rollover.js"
import * as amdModule12 from "./adapters/school-statistic.js"
import * as amdModule13 from "./adapters/school-subscription.ts"
import * as amdModule14 from "./adapters/school.ts"
import * as amdModule15 from "./adapters/standards-set.ts"
import * as amdModule16 from "./adapters/student.ts"
import * as amdModule17 from "./adapters/subscription-coordinator.ts"
import * as amdModule18 from "./adapters/teacher-subscription.ts"
import * as amdModule19 from "./adapters/teacher.ts"
import * as amdModule20 from "./application-error/template.gts"
import * as amdModule21 from "./application/route.ts"
import * as amdModule22 from "./application/template.gts"
import * as amdModule23 from "./config/environment.js"
import * as amdModule24 from "./decorators/query-param.ts"
import * as amdModule25 from "./domain/marketing-regions.ts"
import * as amdModule26 from "./domain/precinct.ts"
import * as amdModule27 from "./domain/product.ts"
import * as amdModule28 from "./domain/subscription-type.ts"
import * as amdModule29 from "./domain/ui-scope.ts"
import * as amdModule30 from "./errors/email-already-exists-error.ts"
import * as amdModule31 from "./errors/http-error.ts"
import * as amdModule32 from "./errors/json-api-errors.ts"
import * as amdModule33 from "./errors/login-already-exists-error.ts"
import * as amdModule34 from "./errors/password-incorrect-error.ts"
import * as amdModule35 from "./instance-initializers/rsvp-error-handler.js"
import * as amdModule36 from "./instance-initializers/start-log.ts"
import * as amdModule37 from "./landing/route.ts"
import * as amdModule38 from "./loading/template.gts"
import * as amdModule39 from "./log-adapters/application.js"
import * as amdModule40 from "./models/contact-detail.ts"
import * as amdModule41 from "./models/district-coordinator.ts"
import * as amdModule42 from "./models/district.ts"
import * as amdModule43 from "./models/import-schedule.ts"
import * as amdModule44 from "./models/import-validation.ts"
import * as amdModule45 from "./models/partner-contact-detail.ts"
import * as amdModule46 from "./models/school-class.ts"
import * as amdModule47 from "./models/school-rollover.ts"
import * as amdModule48 from "./models/school-statistic.ts"
import * as amdModule49 from "./models/school-subscription-utilisation.ts"
import * as amdModule50 from "./models/school-subscription.ts"
import * as amdModule51 from "./models/school.ts"
import * as amdModule52 from "./models/standards-set.ts"
import * as amdModule53 from "./models/student.ts"
import * as amdModule54 from "./models/subscription-coordinator.ts"
import * as amdModule55 from "./models/teacher-subscription.ts"
import * as amdModule56 from "./models/teacher.ts"
import * as amdModule57 from "./reporting/route.ts"
import * as amdModule58 from "./reporting/ui-scope/controller.ts"
import * as amdModule59 from "./reporting/ui-scope/fast-phonics/controller.ts"
import * as amdModule60 from "./reporting/ui-scope/fast-phonics/lesson-performance/controller.ts"
import * as amdModule61 from "./reporting/ui-scope/fast-phonics/lesson-performance/route.ts"
import * as amdModule62 from "./reporting/ui-scope/fast-phonics/lesson-performance/template.gts"
import * as amdModule63 from "./reporting/ui-scope/fast-phonics/route.ts"
import * as amdModule64 from "./reporting/ui-scope/fast-phonics/standards-performance/controller.ts"
import * as amdModule65 from "./reporting/ui-scope/fast-phonics/standards-performance/route.ts"
import * as amdModule66 from "./reporting/ui-scope/fast-phonics/standards-performance/template.gts"
import * as amdModule67 from "./reporting/ui-scope/maths/awards-earned/route.ts"
import * as amdModule68 from "./reporting/ui-scope/maths/awards-earned/template.gts"
import * as amdModule69 from "./reporting/ui-scope/maths/controller.ts"
import * as amdModule70 from "./reporting/ui-scope/maths/course-progress/averages/route.ts"
import * as amdModule71 from "./reporting/ui-scope/maths/course-progress/averages/template.gts"
import * as amdModule72 from "./reporting/ui-scope/maths/course-progress/totals/route.ts"
import * as amdModule73 from "./reporting/ui-scope/maths/course-progress/totals/template.gts"
import * as amdModule74 from "./reporting/ui-scope/maths/dashboard/index/route.ts"
import * as amdModule75 from "./reporting/ui-scope/maths/dashboard/index/template.gts"
import * as amdModule76 from "./reporting/ui-scope/maths/dashboard/table/route.ts"
import * as amdModule77 from "./reporting/ui-scope/maths/dashboard/table/template.gts"
import * as amdModule78 from "./reporting/ui-scope/maths/driving-tests/route.ts"
import * as amdModule79 from "./reporting/ui-scope/maths/driving-tests/template.gts"
import * as amdModule80 from "./reporting/ui-scope/maths/fluency-sprints/table/controller.ts"
import * as amdModule81 from "./reporting/ui-scope/maths/fluency-sprints/table/route.ts"
import * as amdModule82 from "./reporting/ui-scope/maths/fluency-sprints/table/template.gts"
import * as amdModule83 from "./reporting/ui-scope/maths/lesson-performance/controller.ts"
import * as amdModule84 from "./reporting/ui-scope/maths/lesson-performance/route.ts"
import * as amdModule85 from "./reporting/ui-scope/maths/lesson-performance/template.gts"
import * as amdModule86 from "./reporting/ui-scope/maths/quizzes-completed/route.ts"
import * as amdModule87 from "./reporting/ui-scope/maths/quizzes-completed/template.gts"
import * as amdModule88 from "./reporting/ui-scope/maths/route.ts"
import * as amdModule89 from "./reporting/ui-scope/maths/standards-performance/controller.ts"
import * as amdModule90 from "./reporting/ui-scope/maths/standards-performance/route.ts"
import * as amdModule91 from "./reporting/ui-scope/maths/standards-performance/template.gts"
import * as amdModule92 from "./reporting/ui-scope/maths/summary/table/route.ts"
import * as amdModule93 from "./reporting/ui-scope/maths/summary/table/template.gts"
import * as amdModule94 from "./reporting/ui-scope/maths/time-on-task/route.ts"
import * as amdModule95 from "./reporting/ui-scope/maths/time-on-task/template.gts"
import * as amdModule96 from "./reporting/ui-scope/maths/working-at-grade-level/route.ts"
import * as amdModule97 from "./reporting/ui-scope/maths/working-at-grade-level/template.gts"
import * as amdModule98 from "./reporting/ui-scope/mx/controller.ts"
import * as amdModule99 from "./reporting/ui-scope/mx/route.ts"
import * as amdModule100 from "./reporting/ui-scope/mx/standards-performance/controller.ts"
import * as amdModule101 from "./reporting/ui-scope/mx/standards-performance/route.ts"
import * as amdModule102 from "./reporting/ui-scope/mx/standards-performance/template.gts"
import * as amdModule103 from "./reporting/ui-scope/re/awards-earned/route.ts"
import * as amdModule104 from "./reporting/ui-scope/re/awards-earned/template.gts"
import * as amdModule105 from "./reporting/ui-scope/re/books-read/route.ts"
import * as amdModule106 from "./reporting/ui-scope/re/books-read/template.gts"
import * as amdModule107 from "./reporting/ui-scope/re/controller.ts"
import * as amdModule108 from "./reporting/ui-scope/re/course-progress/averages/route.ts"
import * as amdModule109 from "./reporting/ui-scope/re/course-progress/averages/template.gts"
import * as amdModule110 from "./reporting/ui-scope/re/course-progress/totals/route.ts"
import * as amdModule111 from "./reporting/ui-scope/re/course-progress/totals/template.gts"
import * as amdModule112 from "./reporting/ui-scope/re/dashboard/index/route.ts"
import * as amdModule113 from "./reporting/ui-scope/re/dashboard/index/template.gts"
import * as amdModule114 from "./reporting/ui-scope/re/dashboard/table/route.ts"
import * as amdModule115 from "./reporting/ui-scope/re/dashboard/table/template.gts"
import * as amdModule116 from "./reporting/ui-scope/re/driving-tests/route.ts"
import * as amdModule117 from "./reporting/ui-scope/re/driving-tests/template.gts"
import * as amdModule118 from "./reporting/ui-scope/re/lesson-performance/controller.ts"
import * as amdModule119 from "./reporting/ui-scope/re/lesson-performance/route.ts"
import * as amdModule120 from "./reporting/ui-scope/re/lesson-performance/template.gts"
import * as amdModule121 from "./reporting/ui-scope/re/lexile-details/route.ts"
import * as amdModule122 from "./reporting/ui-scope/re/lexile-details/template.gts"
import * as amdModule123 from "./reporting/ui-scope/re/quizzes-completed/route.ts"
import * as amdModule124 from "./reporting/ui-scope/re/quizzes-completed/template.gts"
import * as amdModule125 from "./reporting/ui-scope/re/route.ts"
import * as amdModule126 from "./reporting/ui-scope/re/spelling-progress/averages/route.ts"
import * as amdModule127 from "./reporting/ui-scope/re/spelling-progress/averages/template.gts"
import * as amdModule128 from "./reporting/ui-scope/re/spelling-progress/totals/route.ts"
import * as amdModule129 from "./reporting/ui-scope/re/spelling-progress/totals/template.gts"
import * as amdModule130 from "./reporting/ui-scope/re/standards-performance/controller.ts"
import * as amdModule131 from "./reporting/ui-scope/re/standards-performance/route.ts"
import * as amdModule132 from "./reporting/ui-scope/re/standards-performance/template.gts"
import * as amdModule133 from "./reporting/ui-scope/re/stories-written/route.ts"
import * as amdModule134 from "./reporting/ui-scope/re/stories-written/template.gts"
import * as amdModule135 from "./reporting/ui-scope/re/storylands/route.ts"
import * as amdModule136 from "./reporting/ui-scope/re/storylands/template.gts"
import * as amdModule137 from "./reporting/ui-scope/re/summary/table/route.ts"
import * as amdModule138 from "./reporting/ui-scope/re/summary/table/template.gts"
import * as amdModule139 from "./reporting/ui-scope/re/time-on-task/route.ts"
import * as amdModule140 from "./reporting/ui-scope/re/time-on-task/template.gts"
import * as amdModule141 from "./reporting/ui-scope/re/working-at-grade-level/route.ts"
import * as amdModule142 from "./reporting/ui-scope/re/working-at-grade-level/template.gts"
import * as amdModule143 from "./reporting/ui-scope/rex/assessment-scores/route.ts"
import * as amdModule144 from "./reporting/ui-scope/rex/assessment-scores/template.gts"
import * as amdModule145 from "./reporting/ui-scope/rex/awards-earned/route.ts"
import * as amdModule146 from "./reporting/ui-scope/rex/awards-earned/template.gts"
import * as amdModule147 from "./reporting/ui-scope/rex/books-read/by-level/route.ts"
import * as amdModule148 from "./reporting/ui-scope/rex/books-read/by-level/template.gts"
import * as amdModule149 from "./reporting/ui-scope/rex/books-read/index/route.ts"
import * as amdModule150 from "./reporting/ui-scope/rex/books-read/index/template.gts"
import * as amdModule151 from "./reporting/ui-scope/rex/controller.ts"
import * as amdModule152 from "./reporting/ui-scope/rex/course-progress/averages/route.ts"
import * as amdModule153 from "./reporting/ui-scope/rex/course-progress/averages/template.gts"
import * as amdModule154 from "./reporting/ui-scope/rex/course-progress/totals/route.ts"
import * as amdModule155 from "./reporting/ui-scope/rex/course-progress/totals/template.gts"
import * as amdModule156 from "./reporting/ui-scope/rex/dashboard/index/route.ts"
import * as amdModule157 from "./reporting/ui-scope/rex/dashboard/index/template.gts"
import * as amdModule158 from "./reporting/ui-scope/rex/dashboard/table/route.ts"
import * as amdModule159 from "./reporting/ui-scope/rex/dashboard/table/template.gts"
import * as amdModule160 from "./reporting/ui-scope/rex/lesson-performance/controller.ts"
import * as amdModule161 from "./reporting/ui-scope/rex/lesson-performance/route.ts"
import * as amdModule162 from "./reporting/ui-scope/rex/lesson-performance/template.gts"
import * as amdModule163 from "./reporting/ui-scope/rex/lexile-details/route.ts"
import * as amdModule164 from "./reporting/ui-scope/rex/lexile-details/template.gts"
import * as amdModule165 from "./reporting/ui-scope/rex/quiz-scores/route.ts"
import * as amdModule166 from "./reporting/ui-scope/rex/quiz-scores/template.gts"
import * as amdModule167 from "./reporting/ui-scope/rex/route.ts"
import * as amdModule168 from "./reporting/ui-scope/rex/spelling-progress/averages/route.ts"
import * as amdModule169 from "./reporting/ui-scope/rex/spelling-progress/averages/template.gts"
import * as amdModule170 from "./reporting/ui-scope/rex/spelling-progress/totals/route.ts"
import * as amdModule171 from "./reporting/ui-scope/rex/spelling-progress/totals/template.gts"
import * as amdModule172 from "./reporting/ui-scope/rex/standards-performance/controller.ts"
import * as amdModule173 from "./reporting/ui-scope/rex/standards-performance/route.ts"
import * as amdModule174 from "./reporting/ui-scope/rex/standards-performance/template.gts"
import * as amdModule175 from "./reporting/ui-scope/rex/summary/table/route.ts"
import * as amdModule176 from "./reporting/ui-scope/rex/summary/table/template.gts"
import * as amdModule177 from "./reporting/ui-scope/rex/time-on-task/route.ts"
import * as amdModule178 from "./reporting/ui-scope/rex/time-on-task/template.gts"
import * as amdModule179 from "./reporting/ui-scope/rex/working-at-grade-level/route.ts"
import * as amdModule180 from "./reporting/ui-scope/rex/working-at-grade-level/template.gts"
import * as amdModule181 from "./reporting/ui-scope/route.ts"
import * as amdModule182 from "./reporting/ui-scope/template.gts"
import * as amdModule183 from "./router.js"
import * as amdModule184 from "./serializers/application.ts"
import * as amdModule185 from "./serializers/contact-detail.ts"
import * as amdModule186 from "./serializers/district-coordinator.ts"
import * as amdModule187 from "./serializers/district.js"
import * as amdModule188 from "./serializers/import-schedule.js"
import * as amdModule189 from "./serializers/import-validation.js"
import * as amdModule190 from "./serializers/school-class.ts"
import * as amdModule191 from "./serializers/school-statistic.ts"
import * as amdModule192 from "./serializers/school-subscription-utilisation.ts"
import * as amdModule193 from "./serializers/school-subscription.ts"
import * as amdModule194 from "./serializers/school.ts"
import * as amdModule195 from "./serializers/standards-set.ts"
import * as amdModule196 from "./serializers/student.ts"
import * as amdModule197 from "./serializers/subscription-coordinator.ts"
import * as amdModule198 from "./serializers/teacher-subscription.ts"
import * as amdModule199 from "./serializers/teacher.ts"
import * as amdModule200 from "./services/active-route.ts"
import * as amdModule201 from "./services/add-existing-teachers.ts"
import * as amdModule202 from "./services/analytics.ts"
import * as amdModule203 from "./services/date-filter.ts"
import * as amdModule204 from "./services/email-all-students-csv.ts"
import * as amdModule205 from "./services/external-rostering.ts"
import * as amdModule206 from "./services/feature-control.ts"
import * as amdModule207 from "./services/feature-notification.ts"
import * as amdModule208 from "./services/features.ts"
import * as amdModule209 from "./services/file-download.ts"
import * as amdModule210 from "./services/flash-queue.ts"
import * as amdModule211 from "./services/grade-sets.ts"
import * as amdModule212 from "./services/impression.ts"
import * as amdModule213 from "./services/lesson-info.ts"
import * as amdModule214 from "./services/logout.ts"
import * as amdModule215 from "./services/mx-lesson-level-domain.ts"
import * as amdModule216 from "./services/report-navigator.ts"
import * as amdModule217 from "./services/report-registry.ts"
import * as amdModule218 from "./services/reporting.ts"
import * as amdModule219 from "./services/school-rollover.ts"
import * as amdModule220 from "./services/session.ts"
import * as amdModule221 from "./services/store.ts"
import * as amdModule222 from "./services/student-events.ts"
import * as amdModule223 from "./services/student-import.js"
import * as amdModule224 from "./services/student-operations.ts"
import * as amdModule225 from "./services/table-to-csv.ts"
import * as amdModule226 from "./services/teacher-events.ts"
import * as amdModule227 from "./services/teacher-operations.ts"
import * as amdModule228 from "./services/window.ts"
import * as amdModule229 from "./settings/district-coordinator/template.gts"
import * as amdModule230 from "./settings/district-settings/template.gts"
import * as amdModule231 from "./settings/template.gts"
import * as amdModule232 from "./student-import/error-codes.js"
import * as amdModule233 from "./student-import/import-upload/task.js"
import * as amdModule234 from "./student-import/import/task.js"
import * as amdModule235 from "./student-import/task.js"
import * as amdModule236 from "./student-import/urls.js"
import * as amdModule237 from "./student-import/utils.js"
import * as amdModule238 from "./student-import/validate-upload/task.js"
import * as amdModule239 from "./student-import/validate/task.js"
import * as amdModule240 from "./subscription-type/error/route.ts"
import * as amdModule241 from "./subscription-type/error/template.gts"
import * as amdModule242 from "./subscription-type/error404/route.ts"
import * as amdModule243 from "./subscription-type/error404/template.gts"
import * as amdModule244 from "./subscription-type/index/route.ts"
import * as amdModule245 from "./subscription-type/index/template.gts"
import * as amdModule246 from "./subscription-type/loading/template.gts"
import * as amdModule247 from "./subscription-type/manage/roster/route.ts"
import * as amdModule248 from "./subscription-type/manage/roster/template.gts"
import * as amdModule249 from "./subscription-type/manage/schools-loading/template.gts"
import * as amdModule250 from "./subscription-type/manage/schools/edit/route.ts"
import * as amdModule251 from "./subscription-type/manage/schools/edit/template.gts"
import * as amdModule252 from "./subscription-type/manage/schools/index/route.ts"
import * as amdModule253 from "./subscription-type/manage/schools/index/template.gts"
import * as amdModule254 from "./subscription-type/manage/schools/route.ts"
import * as amdModule255 from "./subscription-type/manage/students-loading/template.gts"
import * as amdModule256 from "./subscription-type/manage/students/edit/route.ts"
import * as amdModule257 from "./subscription-type/manage/students/edit/template.gts"
import * as amdModule258 from "./subscription-type/manage/students/import-students/controller.ts"
import * as amdModule259 from "./subscription-type/manage/students/import-students/route.ts"
import * as amdModule260 from "./subscription-type/manage/students/import-students/template.gts"
import * as amdModule261 from "./subscription-type/manage/students/index/controller.ts"
import * as amdModule262 from "./subscription-type/manage/students/index/route.ts"
import * as amdModule263 from "./subscription-type/manage/students/index/template.gts"
import * as amdModule264 from "./subscription-type/manage/students/new/controller.ts"
import * as amdModule265 from "./subscription-type/manage/students/new/route.ts"
import * as amdModule266 from "./subscription-type/manage/students/new/template.gts"
import * as amdModule267 from "./subscription-type/manage/teachers-loading/template.gts"
import * as amdModule268 from "./subscription-type/manage/teachers/add-existing-teachers/route.ts"
import * as amdModule269 from "./subscription-type/manage/teachers/add-existing-teachers/template.gts"
import * as amdModule270 from "./subscription-type/manage/teachers/edit/route.ts"
import * as amdModule271 from "./subscription-type/manage/teachers/edit/template.gts"
import * as amdModule272 from "./subscription-type/manage/teachers/index/controller.ts"
import * as amdModule273 from "./subscription-type/manage/teachers/index/route.ts"
import * as amdModule274 from "./subscription-type/manage/teachers/index/template.gts"
import * as amdModule275 from "./subscription-type/manage/teachers/new/controller.ts"
import * as amdModule276 from "./subscription-type/manage/teachers/new/route.ts"
import * as amdModule277 from "./subscription-type/manage/teachers/new/template.gts"
import * as amdModule278 from "./subscription-type/manage/template.gts"
import * as amdModule279 from "./subscription-type/route.ts"
import * as amdModule280 from "./subscription-type/support/route.ts"
import * as amdModule281 from "./subscription-type/support/template.gts"
import * as amdModule282 from "./subscription-type/template.gts"
import * as amdModule283 from "./support/route.ts"
import * as amdModule284 from "./transforms/boolean.ts"
import * as amdModule285 from "./transforms/date.ts"
import * as amdModule286 from "./transforms/number.ts"
import * as amdModule287 from "./transforms/string.ts"
import * as amdModule288 from "./utils/bulk-adapter-utils.ts"
import * as amdModule289 from "./utils/bulk-manager.ts"
import * as amdModule290 from "./utils/dates/get-academic-year.ts"
import * as amdModule291 from "./utils/dates/named-date-ranges.ts"
import * as amdModule292 from "./utils/dates/relative-academic-years.ts"
import * as amdModule293 from "./utils/format-duration.ts"
import * as amdModule294 from "./utils/format-humanized-duration.ts"
import * as amdModule295 from "./utils/format-value.ts"
import * as amdModule296 from "./utils/giraffe/average-calculator.ts"
import * as amdModule297 from "./utils/giraffe/convert-date-format.ts"
import * as amdModule298 from "./utils/giraffe/formatter.ts"
import * as amdModule299 from "./utils/giraffe/highcharts-config.ts"
import * as amdModule300 from "./utils/giraffe/highcharts-selectors.ts"
import * as amdModule301 from "./utils/giraffe/lexile-grade-map.ts"
import * as amdModule302 from "./utils/giraffe/lexile-y-range.ts"
import * as amdModule303 from "./utils/giraffe/stateful-sort.ts"
import * as amdModule304 from "./utils/round.ts"
import * as amdModule305 from "./utils/routing.ts"
import * as amdModule306 from "./utils/same-content.ts"
import * as amdModule307 from "./utils/sorting.ts"
import * as amdModule308 from "./utils/student-events/fetchers/assessment-scores-totals.ts"
import * as amdModule309 from "./utils/student-events/fetchers/assessment-scores.ts"
import * as amdModule310 from "./utils/student-events/fetchers/awards-earned-totals.ts"
import * as amdModule311 from "./utils/student-events/fetchers/awards-earned.ts"
import * as amdModule312 from "./utils/student-events/fetchers/books-read-by-genre-totals.ts"
import * as amdModule313 from "./utils/student-events/fetchers/books-read-by-genre.ts"
import * as amdModule314 from "./utils/student-events/fetchers/books-read-by-level-totals.ts"
import * as amdModule315 from "./utils/student-events/fetchers/books-read-by-level.ts"
import * as amdModule316 from "./utils/student-events/fetchers/course-progress-averages.ts"
import * as amdModule317 from "./utils/student-events/fetchers/course-progress-by-grade.ts"
import * as amdModule318 from "./utils/student-events/fetchers/course-progress-totals.ts"
import * as amdModule319 from "./utils/student-events/fetchers/driving-tests-totals-by-grade-by-month.ts"
import * as amdModule320 from "./utils/student-events/fetchers/driving-tests.ts"
import * as amdModule321 from "./utils/student-events/fetchers/lexile-details-averages.ts"
import * as amdModule322 from "./utils/student-events/fetchers/lexile-growth.ts"
import * as amdModule323 from "./utils/student-events/fetchers/mental-minute-school-overview.ts"
import * as amdModule324 from "./utils/student-events/fetchers/mental-minute-summary.ts"
import * as amdModule325 from "./utils/student-events/fetchers/quiz-scores-totals.ts"
import * as amdModule326 from "./utils/student-events/fetchers/simple-summary.ts"
import * as amdModule327 from "./utils/student-events/fetchers/skills-mastered.ts"
import * as amdModule328 from "./utils/student-events/fetchers/stadium-events.ts"
import * as amdModule329 from "./utils/student-events/fetchers/stories-written-by-grade.ts"
import * as amdModule330 from "./utils/student-events/fetchers/stories-written-totals-by-grade-by-month.ts"
import * as amdModule331 from "./utils/student-events/fetchers/storylands-totals-by-grade-by-month.ts"
import * as amdModule332 from "./utils/student-events/fetchers/summary.ts"
import * as amdModule333 from "./utils/student-events/fetchers/time-on-task-history.ts"
import * as amdModule334 from "./utils/student-events/fetchers/time-on-task-usage.ts"
import * as amdModule335 from "./utils/student-events/fetchers/total-usage-over-time.ts"
import * as amdModule336 from "./utils/student-events/fetchers/working-at-grade-level-totals-by-grade.ts"
import * as amdModule337 from "./utils/student-events/fetchers/working-at-grade-level.ts"
import * as amdModule338 from "./utils/student-events/fill-months.ts"
import * as amdModule339 from "./utils/student-events/group-by-grade-position.js"
import * as amdModule340 from "./utils/student-events/stats-scope.ts"
import * as amdModule341 from "./utils/themes.ts"
import * as amdModule342 from "./utils/type-guards.ts"
import * as amdModule343 from "./utils/uri.ts"
import * as amdModule344 from "./services/intl.js"
import * as amdModule345 from "./services/-ensure-registered.js"
import * as amdModule346 from "./services/keyboard.js"
import * as amdModule347 from "./initializers/ember-data.js"
import * as amdModule348 from "./data-adapter.js"
import * as amdModule349 from "./services/flash-messages.js"
import * as amdModule350 from "./index.js"
import * as amdModule351 from "./state/base-state.js"
import * as amdModule352 from "./state/multi-select-state.js"
import * as amdModule353 from "./state/select-box-state.js"
import * as amdModule354 from "./services/data-transformer.js"
import * as amdModule355 from "./services/auth-token.js"
import * as amdModule356 from "./services/fetcher.js"
import * as amdModule357 from "./event-count-checker/service.js"
import * as amdModule358 from "./long-session-killer/service.js"
import * as amdModule359 from "./refresher/service.js"
import * as amdModule360 from "./release-checker/service.js"
import * as amdModule361 from "./session-tracker/service.js"
import * as amdModule362 from "./log-adapters/base.js"
import * as amdModule363 from "./log-adapters/console.js"
import * as amdModule364 from "./log-adapters/rollbar.js"
import * as amdModule365 from "./services/log.js"
import * as amdModule366 from "./device/bind-viewport-height/modifier.js"
import * as amdModule367 from "./device/detection-classes/modifier.js"
import * as amdModule368 from "./device/detection/service.js"
import * as amdModule369 from "./device/network/service.js"
import * as amdModule370 from "./device/viewport/service.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"district-ui-client/adapters/application": amdModule0,
"district-ui-client/adapters/contact-detail": amdModule1,
"district-ui-client/adapters/csv-api": amdModule2,
"district-ui-client/adapters/district-coordinator": amdModule3,
"district-ui-client/adapters/district": amdModule4,
"district-ui-client/adapters/gravity-bulk": amdModule5,
"district-ui-client/adapters/gravity": amdModule6,
"district-ui-client/adapters/import-schedule": amdModule7,
"district-ui-client/adapters/import-validation": amdModule8,
"district-ui-client/adapters/partner-contact-detail": amdModule9,
"district-ui-client/adapters/school-class": amdModule10,
"district-ui-client/adapters/school-rollover": amdModule11,
"district-ui-client/adapters/school-statistic": amdModule12,
"district-ui-client/adapters/school-subscription": amdModule13,
"district-ui-client/adapters/school": amdModule14,
"district-ui-client/adapters/standards-set": amdModule15,
"district-ui-client/adapters/student": amdModule16,
"district-ui-client/adapters/subscription-coordinator": amdModule17,
"district-ui-client/adapters/teacher-subscription": amdModule18,
"district-ui-client/adapters/teacher": amdModule19,
"district-ui-client/application-error/template": amdModule20,
"district-ui-client/application/route": amdModule21,
"district-ui-client/application/template": amdModule22,
"district-ui-client/config/environment": amdModule23,
"district-ui-client/decorators/query-param": amdModule24,
"district-ui-client/domain/marketing-regions": amdModule25,
"district-ui-client/domain/precinct": amdModule26,
"district-ui-client/domain/product": amdModule27,
"district-ui-client/domain/subscription-type": amdModule28,
"district-ui-client/domain/ui-scope": amdModule29,
"district-ui-client/errors/email-already-exists-error": amdModule30,
"district-ui-client/errors/http-error": amdModule31,
"district-ui-client/errors/json-api-errors": amdModule32,
"district-ui-client/errors/login-already-exists-error": amdModule33,
"district-ui-client/errors/password-incorrect-error": amdModule34,
"district-ui-client/instance-initializers/rsvp-error-handler": amdModule35,
"district-ui-client/instance-initializers/start-log": amdModule36,
"district-ui-client/landing/route": amdModule37,
"district-ui-client/loading/template": amdModule38,
"district-ui-client/log-adapters/application": amdModule39,
"district-ui-client/models/contact-detail": amdModule40,
"district-ui-client/models/district-coordinator": amdModule41,
"district-ui-client/models/district": amdModule42,
"district-ui-client/models/import-schedule": amdModule43,
"district-ui-client/models/import-validation": amdModule44,
"district-ui-client/models/partner-contact-detail": amdModule45,
"district-ui-client/models/school-class": amdModule46,
"district-ui-client/models/school-rollover": amdModule47,
"district-ui-client/models/school-statistic": amdModule48,
"district-ui-client/models/school-subscription-utilisation": amdModule49,
"district-ui-client/models/school-subscription": amdModule50,
"district-ui-client/models/school": amdModule51,
"district-ui-client/models/standards-set": amdModule52,
"district-ui-client/models/student": amdModule53,
"district-ui-client/models/subscription-coordinator": amdModule54,
"district-ui-client/models/teacher-subscription": amdModule55,
"district-ui-client/models/teacher": amdModule56,
"district-ui-client/reporting/route": amdModule57,
"district-ui-client/reporting/ui-scope/controller": amdModule58,
"district-ui-client/reporting/ui-scope/fast-phonics/controller": amdModule59,
"district-ui-client/reporting/ui-scope/fast-phonics/lesson-performance/controller": amdModule60,
"district-ui-client/reporting/ui-scope/fast-phonics/lesson-performance/route": amdModule61,
"district-ui-client/reporting/ui-scope/fast-phonics/lesson-performance/template": amdModule62,
"district-ui-client/reporting/ui-scope/fast-phonics/route": amdModule63,
"district-ui-client/reporting/ui-scope/fast-phonics/standards-performance/controller": amdModule64,
"district-ui-client/reporting/ui-scope/fast-phonics/standards-performance/route": amdModule65,
"district-ui-client/reporting/ui-scope/fast-phonics/standards-performance/template": amdModule66,
"district-ui-client/reporting/ui-scope/maths/awards-earned/route": amdModule67,
"district-ui-client/reporting/ui-scope/maths/awards-earned/template": amdModule68,
"district-ui-client/reporting/ui-scope/maths/controller": amdModule69,
"district-ui-client/reporting/ui-scope/maths/course-progress/averages/route": amdModule70,
"district-ui-client/reporting/ui-scope/maths/course-progress/averages/template": amdModule71,
"district-ui-client/reporting/ui-scope/maths/course-progress/totals/route": amdModule72,
"district-ui-client/reporting/ui-scope/maths/course-progress/totals/template": amdModule73,
"district-ui-client/reporting/ui-scope/maths/dashboard/index/route": amdModule74,
"district-ui-client/reporting/ui-scope/maths/dashboard/index/template": amdModule75,
"district-ui-client/reporting/ui-scope/maths/dashboard/table/route": amdModule76,
"district-ui-client/reporting/ui-scope/maths/dashboard/table/template": amdModule77,
"district-ui-client/reporting/ui-scope/maths/driving-tests/route": amdModule78,
"district-ui-client/reporting/ui-scope/maths/driving-tests/template": amdModule79,
"district-ui-client/reporting/ui-scope/maths/fluency-sprints/table/controller": amdModule80,
"district-ui-client/reporting/ui-scope/maths/fluency-sprints/table/route": amdModule81,
"district-ui-client/reporting/ui-scope/maths/fluency-sprints/table/template": amdModule82,
"district-ui-client/reporting/ui-scope/maths/lesson-performance/controller": amdModule83,
"district-ui-client/reporting/ui-scope/maths/lesson-performance/route": amdModule84,
"district-ui-client/reporting/ui-scope/maths/lesson-performance/template": amdModule85,
"district-ui-client/reporting/ui-scope/maths/quizzes-completed/route": amdModule86,
"district-ui-client/reporting/ui-scope/maths/quizzes-completed/template": amdModule87,
"district-ui-client/reporting/ui-scope/maths/route": amdModule88,
"district-ui-client/reporting/ui-scope/maths/standards-performance/controller": amdModule89,
"district-ui-client/reporting/ui-scope/maths/standards-performance/route": amdModule90,
"district-ui-client/reporting/ui-scope/maths/standards-performance/template": amdModule91,
"district-ui-client/reporting/ui-scope/maths/summary/table/route": amdModule92,
"district-ui-client/reporting/ui-scope/maths/summary/table/template": amdModule93,
"district-ui-client/reporting/ui-scope/maths/time-on-task/route": amdModule94,
"district-ui-client/reporting/ui-scope/maths/time-on-task/template": amdModule95,
"district-ui-client/reporting/ui-scope/maths/working-at-grade-level/route": amdModule96,
"district-ui-client/reporting/ui-scope/maths/working-at-grade-level/template": amdModule97,
"district-ui-client/reporting/ui-scope/mx/controller": amdModule98,
"district-ui-client/reporting/ui-scope/mx/route": amdModule99,
"district-ui-client/reporting/ui-scope/mx/standards-performance/controller": amdModule100,
"district-ui-client/reporting/ui-scope/mx/standards-performance/route": amdModule101,
"district-ui-client/reporting/ui-scope/mx/standards-performance/template": amdModule102,
"district-ui-client/reporting/ui-scope/re/awards-earned/route": amdModule103,
"district-ui-client/reporting/ui-scope/re/awards-earned/template": amdModule104,
"district-ui-client/reporting/ui-scope/re/books-read/route": amdModule105,
"district-ui-client/reporting/ui-scope/re/books-read/template": amdModule106,
"district-ui-client/reporting/ui-scope/re/controller": amdModule107,
"district-ui-client/reporting/ui-scope/re/course-progress/averages/route": amdModule108,
"district-ui-client/reporting/ui-scope/re/course-progress/averages/template": amdModule109,
"district-ui-client/reporting/ui-scope/re/course-progress/totals/route": amdModule110,
"district-ui-client/reporting/ui-scope/re/course-progress/totals/template": amdModule111,
"district-ui-client/reporting/ui-scope/re/dashboard/index/route": amdModule112,
"district-ui-client/reporting/ui-scope/re/dashboard/index/template": amdModule113,
"district-ui-client/reporting/ui-scope/re/dashboard/table/route": amdModule114,
"district-ui-client/reporting/ui-scope/re/dashboard/table/template": amdModule115,
"district-ui-client/reporting/ui-scope/re/driving-tests/route": amdModule116,
"district-ui-client/reporting/ui-scope/re/driving-tests/template": amdModule117,
"district-ui-client/reporting/ui-scope/re/lesson-performance/controller": amdModule118,
"district-ui-client/reporting/ui-scope/re/lesson-performance/route": amdModule119,
"district-ui-client/reporting/ui-scope/re/lesson-performance/template": amdModule120,
"district-ui-client/reporting/ui-scope/re/lexile-details/route": amdModule121,
"district-ui-client/reporting/ui-scope/re/lexile-details/template": amdModule122,
"district-ui-client/reporting/ui-scope/re/quizzes-completed/route": amdModule123,
"district-ui-client/reporting/ui-scope/re/quizzes-completed/template": amdModule124,
"district-ui-client/reporting/ui-scope/re/route": amdModule125,
"district-ui-client/reporting/ui-scope/re/spelling-progress/averages/route": amdModule126,
"district-ui-client/reporting/ui-scope/re/spelling-progress/averages/template": amdModule127,
"district-ui-client/reporting/ui-scope/re/spelling-progress/totals/route": amdModule128,
"district-ui-client/reporting/ui-scope/re/spelling-progress/totals/template": amdModule129,
"district-ui-client/reporting/ui-scope/re/standards-performance/controller": amdModule130,
"district-ui-client/reporting/ui-scope/re/standards-performance/route": amdModule131,
"district-ui-client/reporting/ui-scope/re/standards-performance/template": amdModule132,
"district-ui-client/reporting/ui-scope/re/stories-written/route": amdModule133,
"district-ui-client/reporting/ui-scope/re/stories-written/template": amdModule134,
"district-ui-client/reporting/ui-scope/re/storylands/route": amdModule135,
"district-ui-client/reporting/ui-scope/re/storylands/template": amdModule136,
"district-ui-client/reporting/ui-scope/re/summary/table/route": amdModule137,
"district-ui-client/reporting/ui-scope/re/summary/table/template": amdModule138,
"district-ui-client/reporting/ui-scope/re/time-on-task/route": amdModule139,
"district-ui-client/reporting/ui-scope/re/time-on-task/template": amdModule140,
"district-ui-client/reporting/ui-scope/re/working-at-grade-level/route": amdModule141,
"district-ui-client/reporting/ui-scope/re/working-at-grade-level/template": amdModule142,
"district-ui-client/reporting/ui-scope/rex/assessment-scores/route": amdModule143,
"district-ui-client/reporting/ui-scope/rex/assessment-scores/template": amdModule144,
"district-ui-client/reporting/ui-scope/rex/awards-earned/route": amdModule145,
"district-ui-client/reporting/ui-scope/rex/awards-earned/template": amdModule146,
"district-ui-client/reporting/ui-scope/rex/books-read/by-level/route": amdModule147,
"district-ui-client/reporting/ui-scope/rex/books-read/by-level/template": amdModule148,
"district-ui-client/reporting/ui-scope/rex/books-read/index/route": amdModule149,
"district-ui-client/reporting/ui-scope/rex/books-read/index/template": amdModule150,
"district-ui-client/reporting/ui-scope/rex/controller": amdModule151,
"district-ui-client/reporting/ui-scope/rex/course-progress/averages/route": amdModule152,
"district-ui-client/reporting/ui-scope/rex/course-progress/averages/template": amdModule153,
"district-ui-client/reporting/ui-scope/rex/course-progress/totals/route": amdModule154,
"district-ui-client/reporting/ui-scope/rex/course-progress/totals/template": amdModule155,
"district-ui-client/reporting/ui-scope/rex/dashboard/index/route": amdModule156,
"district-ui-client/reporting/ui-scope/rex/dashboard/index/template": amdModule157,
"district-ui-client/reporting/ui-scope/rex/dashboard/table/route": amdModule158,
"district-ui-client/reporting/ui-scope/rex/dashboard/table/template": amdModule159,
"district-ui-client/reporting/ui-scope/rex/lesson-performance/controller": amdModule160,
"district-ui-client/reporting/ui-scope/rex/lesson-performance/route": amdModule161,
"district-ui-client/reporting/ui-scope/rex/lesson-performance/template": amdModule162,
"district-ui-client/reporting/ui-scope/rex/lexile-details/route": amdModule163,
"district-ui-client/reporting/ui-scope/rex/lexile-details/template": amdModule164,
"district-ui-client/reporting/ui-scope/rex/quiz-scores/route": amdModule165,
"district-ui-client/reporting/ui-scope/rex/quiz-scores/template": amdModule166,
"district-ui-client/reporting/ui-scope/rex/route": amdModule167,
"district-ui-client/reporting/ui-scope/rex/spelling-progress/averages/route": amdModule168,
"district-ui-client/reporting/ui-scope/rex/spelling-progress/averages/template": amdModule169,
"district-ui-client/reporting/ui-scope/rex/spelling-progress/totals/route": amdModule170,
"district-ui-client/reporting/ui-scope/rex/spelling-progress/totals/template": amdModule171,
"district-ui-client/reporting/ui-scope/rex/standards-performance/controller": amdModule172,
"district-ui-client/reporting/ui-scope/rex/standards-performance/route": amdModule173,
"district-ui-client/reporting/ui-scope/rex/standards-performance/template": amdModule174,
"district-ui-client/reporting/ui-scope/rex/summary/table/route": amdModule175,
"district-ui-client/reporting/ui-scope/rex/summary/table/template": amdModule176,
"district-ui-client/reporting/ui-scope/rex/time-on-task/route": amdModule177,
"district-ui-client/reporting/ui-scope/rex/time-on-task/template": amdModule178,
"district-ui-client/reporting/ui-scope/rex/working-at-grade-level/route": amdModule179,
"district-ui-client/reporting/ui-scope/rex/working-at-grade-level/template": amdModule180,
"district-ui-client/reporting/ui-scope/route": amdModule181,
"district-ui-client/reporting/ui-scope/template": amdModule182,
"district-ui-client/router": amdModule183,
"district-ui-client/serializers/application": amdModule184,
"district-ui-client/serializers/contact-detail": amdModule185,
"district-ui-client/serializers/district-coordinator": amdModule186,
"district-ui-client/serializers/district": amdModule187,
"district-ui-client/serializers/import-schedule": amdModule188,
"district-ui-client/serializers/import-validation": amdModule189,
"district-ui-client/serializers/school-class": amdModule190,
"district-ui-client/serializers/school-statistic": amdModule191,
"district-ui-client/serializers/school-subscription-utilisation": amdModule192,
"district-ui-client/serializers/school-subscription": amdModule193,
"district-ui-client/serializers/school": amdModule194,
"district-ui-client/serializers/standards-set": amdModule195,
"district-ui-client/serializers/student": amdModule196,
"district-ui-client/serializers/subscription-coordinator": amdModule197,
"district-ui-client/serializers/teacher-subscription": amdModule198,
"district-ui-client/serializers/teacher": amdModule199,
"district-ui-client/services/active-route": amdModule200,
"district-ui-client/services/add-existing-teachers": amdModule201,
"district-ui-client/services/analytics": amdModule202,
"district-ui-client/services/date-filter": amdModule203,
"district-ui-client/services/email-all-students-csv": amdModule204,
"district-ui-client/services/external-rostering": amdModule205,
"district-ui-client/services/feature-control": amdModule206,
"district-ui-client/services/feature-notification": amdModule207,
"district-ui-client/services/features": amdModule208,
"district-ui-client/services/file-download": amdModule209,
"district-ui-client/services/flash-queue": amdModule210,
"district-ui-client/services/grade-sets": amdModule211,
"district-ui-client/services/impression": amdModule212,
"district-ui-client/services/lesson-info": amdModule213,
"district-ui-client/services/logout": amdModule214,
"district-ui-client/services/mx-lesson-level-domain": amdModule215,
"district-ui-client/services/report-navigator": amdModule216,
"district-ui-client/services/report-registry": amdModule217,
"district-ui-client/services/reporting": amdModule218,
"district-ui-client/services/school-rollover": amdModule219,
"district-ui-client/services/session": amdModule220,
"district-ui-client/services/store": amdModule221,
"district-ui-client/services/student-events": amdModule222,
"district-ui-client/services/student-import": amdModule223,
"district-ui-client/services/student-operations": amdModule224,
"district-ui-client/services/table-to-csv": amdModule225,
"district-ui-client/services/teacher-events": amdModule226,
"district-ui-client/services/teacher-operations": amdModule227,
"district-ui-client/services/window": amdModule228,
"district-ui-client/settings/district-coordinator/template": amdModule229,
"district-ui-client/settings/district-settings/template": amdModule230,
"district-ui-client/settings/template": amdModule231,
"district-ui-client/student-import/error-codes": amdModule232,
"district-ui-client/student-import/import-upload/task": amdModule233,
"district-ui-client/student-import/import/task": amdModule234,
"district-ui-client/student-import/task": amdModule235,
"district-ui-client/student-import/urls": amdModule236,
"district-ui-client/student-import/utils": amdModule237,
"district-ui-client/student-import/validate-upload/task": amdModule238,
"district-ui-client/student-import/validate/task": amdModule239,
"district-ui-client/subscription-type/error/route": amdModule240,
"district-ui-client/subscription-type/error/template": amdModule241,
"district-ui-client/subscription-type/error404/route": amdModule242,
"district-ui-client/subscription-type/error404/template": amdModule243,
"district-ui-client/subscription-type/index/route": amdModule244,
"district-ui-client/subscription-type/index/template": amdModule245,
"district-ui-client/subscription-type/loading/template": amdModule246,
"district-ui-client/subscription-type/manage/roster/route": amdModule247,
"district-ui-client/subscription-type/manage/roster/template": amdModule248,
"district-ui-client/subscription-type/manage/schools-loading/template": amdModule249,
"district-ui-client/subscription-type/manage/schools/edit/route": amdModule250,
"district-ui-client/subscription-type/manage/schools/edit/template": amdModule251,
"district-ui-client/subscription-type/manage/schools/index/route": amdModule252,
"district-ui-client/subscription-type/manage/schools/index/template": amdModule253,
"district-ui-client/subscription-type/manage/schools/route": amdModule254,
"district-ui-client/subscription-type/manage/students-loading/template": amdModule255,
"district-ui-client/subscription-type/manage/students/edit/route": amdModule256,
"district-ui-client/subscription-type/manage/students/edit/template": amdModule257,
"district-ui-client/subscription-type/manage/students/import-students/controller": amdModule258,
"district-ui-client/subscription-type/manage/students/import-students/route": amdModule259,
"district-ui-client/subscription-type/manage/students/import-students/template": amdModule260,
"district-ui-client/subscription-type/manage/students/index/controller": amdModule261,
"district-ui-client/subscription-type/manage/students/index/route": amdModule262,
"district-ui-client/subscription-type/manage/students/index/template": amdModule263,
"district-ui-client/subscription-type/manage/students/new/controller": amdModule264,
"district-ui-client/subscription-type/manage/students/new/route": amdModule265,
"district-ui-client/subscription-type/manage/students/new/template": amdModule266,
"district-ui-client/subscription-type/manage/teachers-loading/template": amdModule267,
"district-ui-client/subscription-type/manage/teachers/add-existing-teachers/route": amdModule268,
"district-ui-client/subscription-type/manage/teachers/add-existing-teachers/template": amdModule269,
"district-ui-client/subscription-type/manage/teachers/edit/route": amdModule270,
"district-ui-client/subscription-type/manage/teachers/edit/template": amdModule271,
"district-ui-client/subscription-type/manage/teachers/index/controller": amdModule272,
"district-ui-client/subscription-type/manage/teachers/index/route": amdModule273,
"district-ui-client/subscription-type/manage/teachers/index/template": amdModule274,
"district-ui-client/subscription-type/manage/teachers/new/controller": amdModule275,
"district-ui-client/subscription-type/manage/teachers/new/route": amdModule276,
"district-ui-client/subscription-type/manage/teachers/new/template": amdModule277,
"district-ui-client/subscription-type/manage/template": amdModule278,
"district-ui-client/subscription-type/route": amdModule279,
"district-ui-client/subscription-type/support/route": amdModule280,
"district-ui-client/subscription-type/support/template": amdModule281,
"district-ui-client/subscription-type/template": amdModule282,
"district-ui-client/support/route": amdModule283,
"district-ui-client/transforms/boolean": amdModule284,
"district-ui-client/transforms/date": amdModule285,
"district-ui-client/transforms/number": amdModule286,
"district-ui-client/transforms/string": amdModule287,
"district-ui-client/utils/bulk-adapter-utils": amdModule288,
"district-ui-client/utils/bulk-manager": amdModule289,
"district-ui-client/utils/dates/get-academic-year": amdModule290,
"district-ui-client/utils/dates/named-date-ranges": amdModule291,
"district-ui-client/utils/dates/relative-academic-years": amdModule292,
"district-ui-client/utils/format-duration": amdModule293,
"district-ui-client/utils/format-humanized-duration": amdModule294,
"district-ui-client/utils/format-value": amdModule295,
"district-ui-client/utils/giraffe/average-calculator": amdModule296,
"district-ui-client/utils/giraffe/convert-date-format": amdModule297,
"district-ui-client/utils/giraffe/formatter": amdModule298,
"district-ui-client/utils/giraffe/highcharts-config": amdModule299,
"district-ui-client/utils/giraffe/highcharts-selectors": amdModule300,
"district-ui-client/utils/giraffe/lexile-grade-map": amdModule301,
"district-ui-client/utils/giraffe/lexile-y-range": amdModule302,
"district-ui-client/utils/giraffe/stateful-sort": amdModule303,
"district-ui-client/utils/round": amdModule304,
"district-ui-client/utils/routing": amdModule305,
"district-ui-client/utils/same-content": amdModule306,
"district-ui-client/utils/sorting": amdModule307,
"district-ui-client/utils/student-events/fetchers/assessment-scores-totals": amdModule308,
"district-ui-client/utils/student-events/fetchers/assessment-scores": amdModule309,
"district-ui-client/utils/student-events/fetchers/awards-earned-totals": amdModule310,
"district-ui-client/utils/student-events/fetchers/awards-earned": amdModule311,
"district-ui-client/utils/student-events/fetchers/books-read-by-genre-totals": amdModule312,
"district-ui-client/utils/student-events/fetchers/books-read-by-genre": amdModule313,
"district-ui-client/utils/student-events/fetchers/books-read-by-level-totals": amdModule314,
"district-ui-client/utils/student-events/fetchers/books-read-by-level": amdModule315,
"district-ui-client/utils/student-events/fetchers/course-progress-averages": amdModule316,
"district-ui-client/utils/student-events/fetchers/course-progress-by-grade": amdModule317,
"district-ui-client/utils/student-events/fetchers/course-progress-totals": amdModule318,
"district-ui-client/utils/student-events/fetchers/driving-tests-totals-by-grade-by-month": amdModule319,
"district-ui-client/utils/student-events/fetchers/driving-tests": amdModule320,
"district-ui-client/utils/student-events/fetchers/lexile-details-averages": amdModule321,
"district-ui-client/utils/student-events/fetchers/lexile-growth": amdModule322,
"district-ui-client/utils/student-events/fetchers/mental-minute-school-overview": amdModule323,
"district-ui-client/utils/student-events/fetchers/mental-minute-summary": amdModule324,
"district-ui-client/utils/student-events/fetchers/quiz-scores-totals": amdModule325,
"district-ui-client/utils/student-events/fetchers/simple-summary": amdModule326,
"district-ui-client/utils/student-events/fetchers/skills-mastered": amdModule327,
"district-ui-client/utils/student-events/fetchers/stadium-events": amdModule328,
"district-ui-client/utils/student-events/fetchers/stories-written-by-grade": amdModule329,
"district-ui-client/utils/student-events/fetchers/stories-written-totals-by-grade-by-month": amdModule330,
"district-ui-client/utils/student-events/fetchers/storylands-totals-by-grade-by-month": amdModule331,
"district-ui-client/utils/student-events/fetchers/summary": amdModule332,
"district-ui-client/utils/student-events/fetchers/time-on-task-history": amdModule333,
"district-ui-client/utils/student-events/fetchers/time-on-task-usage": amdModule334,
"district-ui-client/utils/student-events/fetchers/total-usage-over-time": amdModule335,
"district-ui-client/utils/student-events/fetchers/working-at-grade-level-totals-by-grade": amdModule336,
"district-ui-client/utils/student-events/fetchers/working-at-grade-level": amdModule337,
"district-ui-client/utils/student-events/fill-months": amdModule338,
"district-ui-client/utils/student-events/group-by-grade-position": amdModule339,
"district-ui-client/utils/student-events/stats-scope": amdModule340,
"district-ui-client/utils/themes": amdModule341,
"district-ui-client/utils/type-guards": amdModule342,
"district-ui-client/utils/uri": amdModule343,
"district-ui-client/services/intl": amdModule344,
"district-ui-client/services/-ensure-registered": amdModule345,
"district-ui-client/services/keyboard": amdModule346,
"district-ui-client/initializers/ember-data": amdModule347,
"district-ui-client/data-adapter": amdModule348,
"district-ui-client/services/flash-messages": amdModule349,
"district-ui-client/index": amdModule350,
"district-ui-client/state/base-state": amdModule351,
"district-ui-client/state/multi-select-state": amdModule352,
"district-ui-client/state/select-box-state": amdModule353,
"district-ui-client/services/data-transformer": amdModule354,
"district-ui-client/services/auth-token": amdModule355,
"district-ui-client/services/fetcher": amdModule356,
"district-ui-client/event-count-checker/service": amdModule357,
"district-ui-client/long-session-killer/service": amdModule358,
"district-ui-client/refresher/service": amdModule359,
"district-ui-client/release-checker/service": amdModule360,
"district-ui-client/session-tracker/service": amdModule361,
"district-ui-client/log-adapters/base": amdModule362,
"district-ui-client/log-adapters/console": amdModule363,
"district-ui-client/log-adapters/rollbar": amdModule364,
"district-ui-client/services/log": amdModule365,
"district-ui-client/device/bind-viewport-height/modifier": amdModule366,
"district-ui-client/device/detection-classes/modifier": amdModule367,
"district-ui-client/device/detection/service": amdModule368,
"district-ui-client/device/network/service": amdModule369,
"district-ui-client/device/viewport/service": amdModule370,
  },
  exportFastbootModules
);
